<script setup lang="ts">
import { cn } from 'pejer/src/lib/utils'
import { Switch } from 'pejer/src/components/ui/switch'
import { toRef } from 'vue'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'pejer/src/components/ui/alert-dialog'
import { useRouter } from 'vue-router'
import { usePejerBase } from '../../stores/pejerData'

const store = usePejerBase()

const router = useRouter()

const props = defineProps<{
  class?: String
}>()

const handleChange = () => {
  store.setEnviroment(store.state.enviroment.value === 'test' ? 'production' : 'test')
  router.go(0)
}
</script>

<template>
  <nav
    :class="
      cn(
        'w-full h-[--topbar-height] flex fixed bg-primaryBlue rounded-b-lg justify-center items-center px-4',
        props.class
      )
    "
  >
    <div class="flex flex-col items-center gap-1">
      <div
        class="text-xs grid grid-cols-1 xl:grid-cols-3 w-56 items-center justify-center text-white"
      >
        <span
          class="text-right"
          :class="{
            'font-semibold': store.state.enviroment.value === 'test',
            'font-light': store.state.enviroment.value !== 'test',
          }"
          >Testing</span
        >

        <AlertDialog>
          <AlertDialogTrigger as-child>
            <Switch
              class="justify-self-center"
              :checked="store.state.enviroment.value === 'production'"
            />
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Are you sure?</AlertDialogTitle>
              <AlertDialogDescription>
                <span v-if="store.state.enviroment.value === 'test'"
                  >You will enter the <b>production</b> enviroment and your actions and the data
                  will be real.</span
                >
                <span v-else
                  >You will enter the <b>test</b> enviroment and all the data and actions will be
                  used on test data.</span
                >
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction @click="handleChange">Continue</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>

        <span
          class=""
          :class="{
            'font-semibold': store.state.enviroment.value === 'production',
            'font-light': store.state.enviroment.value !== 'production',
          }"
          >Production</span
        >
      </div>
    </div>
  </nav>
</template>

<style scoped></style>
